<template>
    <header class="cr-p5">
        <cr-navigation-bar :label="t('CHALLENGE_HEADER_NAVIGATION_BAR_LABEL')" height="var(--cr-nav-bar-height)" data-testing="challenge-header-nav-bar">
            <router-link :to="Route.LevelSelect" class="title-link" data-testing="challenge-header-title-link">
                <span class="title cr-m0" data-testing="challenge-header-title">{{ t('CHALLENGE_HEADER_TITLE_MAIN') }}<span class="accent">{{ t('CHALLENGE_HEADER_TITLE_ACCENT') }}</span></span>
            </router-link>
            <span class="header-text" data-testing="challenge-header-level-name">{{ levelName }}</span>
            <span>
                <span v-if="showScore" class="header-text" data-testing="challenge-header-star-counter">
                    <span v-if="isComplete" class="complete-score">
                        <cr-icon color="cr-splash-accent" medium :alt="t('CHALLENGE_HEADER_COMPLETE_ALT')" data-testing="challenge-header-complete-icon">bi-award-fill</cr-icon>
                        {{ score }}
                    </span>
                    <template v-else>
                        <cr-image src="/filled-star.svg" :alt="t('CHALLENGE_HEADER_STARS_ALT')" height="2rem" class="cr-pb1 cr-pr1"/>
                        {{ score }}<template v-if="threshold"> / {{ threshold }}</template>
                    </template>
                </span>
            </span>
        </cr-navigation-bar>
    </header>
</template>

<style scoped>
header
{
    width: 100%;
}
.title
{
    font-size: 2.25rem;
    font-weight: 800;
    letter-spacing: 0.04em;
    line-height: 1;
}
.accent
{
    color: var(--cr-splash-accent) !important;
}
.header-text
{
    font-size: 1.5rem;
}
.title-link
{
    text-decoration: none;
}
.complete-score
{
    display: inline-flex;
    align-items: center;
    gap: 0.25rem;
}
</style>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import Route from '../routers/route';
import ILevel from '../interfaces/iLevel';
import { computed, watch } from 'vue';
import { useAnnouncementStore } from '@cyber-range/cyber-range-lib-ui';

const { t } = useI18n();

const props = defineProps<
{
    level?: ILevel;
    score?: number;
    showScore?: boolean;
    threshold?: number;
}>();

const levelName = computed(() => props.level ? t('CHALLENGE_HEADER_LEVEL_NAME', { namePrefix: props.level.namePrefix, nameSuffix: props.level.nameSuffix }) : '');
const score = computed(() => props.score || 0);
const threshold = computed(() => props.threshold || 0);
const isComplete = computed(() => threshold.value > 0 && score.value >= threshold.value);

watch(score, (newScore) =>
{
    if (props.showScore)
    {
        useAnnouncementStore().announce(t('CHALLENGE_HEADER_SCORE_ANNOUNCEMENT', { n: newScore }, newScore));
    }
});
</script>
